import React from 'react'

const TicketUpdates = () => {
  return (
    <div>TicketUpdates</div>
  )
}

export default TicketUpdates